/**
 * Handles size range scrolling, unit switching, tab navigation,
 * body measurement sub-tabs, and how-to-measure guide selection
 * for size guide drawer content. Uses event delegation.
 */

function setUnit(container, unit) {
  for (const cell of container.querySelectorAll("[data-cm][data-in]")) {
    cell.textContent = unit === "inches" ? cell.dataset.in : cell.dataset.cm;
  }
}

function scrollToRange(content, groupIndex) {
  for (const btn of content.querySelectorAll("[data-size-range]")) {
    btn.classList.toggle("active", btn.dataset.sizeRange === groupIndex);
  }

  const scrollContainer = content.querySelector("[data-size-guide-scroll]");
  const firstCol = content.querySelector(`[data-size-group="${groupIndex}"]`);
  if (!scrollContainer || !firstCol) return;

  const stickyCol = scrollContainer.querySelector("th:first-child, td:first-child");
  const stickyWidth = stickyCol ? stickyCol.offsetWidth : 0;

  scrollContainer.scrollTo({
    left: firstCol.offsetLeft - stickyWidth,
    behavior: "smooth"
  });
}

function activateTab(container, tabAttr, panelAttr, activeValue) {
  for (const tab of container.querySelectorAll(`[${tabAttr}]`)) {
    const isActive = tab.getAttribute(tabAttr) === activeValue;
    tab.classList.toggle("active", isActive);
    tab.setAttribute("aria-selected", String(isActive));
  }

  for (const panel of container.querySelectorAll(`[${panelAttr}]`)) {
    panel.hidden = panel.getAttribute(panelAttr) !== activeValue;
  }
}

document.addEventListener("click", (evt) => {
  const sgTab = evt.target.closest("[data-sg-tab]");
  if (sgTab) {
    evt.preventDefault();
    const drawer = sgTab.closest(".drawer__inner");
    activateTab(drawer, "data-sg-tab", "data-sg-panel", sgTab.dataset.sgTab);
    return;
  }

  const content = evt.target.closest("[data-size-guide-content]");
  if (!content) return;

  const bodyTab = evt.target.closest("[data-body-tab]");
  if (bodyTab) {
    evt.preventDefault();
    const panel = bodyTab.closest("[data-sg-panel]");
    activateTab(panel, "data-body-tab", "data-body-panel", bodyTab.dataset.bodyTab);
    return;
  }

  const rangeBtn = evt.target.closest("[data-size-range]");
  if (rangeBtn) {
    evt.preventDefault();
    scrollToRange(content, rangeBtn.dataset.sizeRange);
    return;
  }

  const unitToggle = evt.target.closest("[data-size-guide-unit-toggle]");
  if (unitToggle) {
    evt.preventDefault();
    const next = unitToggle.dataset.activeUnit === "inches" ? "cm" : "inches";
    unitToggle.dataset.activeUnit = next;
    const label = unitToggle.querySelector("[data-unit-label]");
    if (label) label.textContent = next === "inches" ? "Inch" : "Cm";
    setUnit(content, next);
  }
});
